import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { publicApi } from "@/lib/api";
import { CheckCircle2, AlertTriangle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [state, setState] = useState("loading"); // loading | ok | error
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); setErrorMsg("Brak tokenu w linku"); return; }
    publicApi.post("/auth/verify-email", { token })
      .then(() => setState("ok"))
      .catch((err) => {
        setState("error");
        setErrorMsg(err.response?.data?.detail || "Token wygasł lub jest nieprawidłowy");
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-6">
      <div className="w-full max-w-md brut bg-white rounded-md p-8 text-center" data-testid={`verify-${state}`}>
        {state === "loading" && (
          <>
            <Loader2 className="w-12 h-12 mx-auto mb-4 animate-spin" strokeWidth={2.5} />
            <h1 className="font-display font-black text-2xl">Weryfikuję e-mail...</h1>
          </>
        )}
        {state === "ok" && (
          <>
            <div className="brut bg-[#D1FAE5] w-16 h-16 rounded-md flex items-center justify-center mx-auto mb-4">
              <CheckCircle2 className="w-8 h-8" strokeWidth={2.5} />
            </div>
            <h1 className="font-display font-black text-2xl mb-3">E-mail potwierdzony</h1>
            <p className="text-[#334155] mb-6">Możesz teraz zalogować się do swojego konta.</p>
            <Link to="/teacher/login">
              <Button className="w-full brut brut-hover bg-[#0F172A] hover:bg-[#0F172A] text-white font-bold rounded-md">
                Przejdź do logowania
              </Button>
            </Link>
          </>
        )}
        {state === "error" && (
          <>
            <div className="brut bg-[#FEE2E2] w-16 h-16 rounded-md flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="w-8 h-8" strokeWidth={2.5} />
            </div>
            <h1 className="font-display font-black text-2xl mb-3">Coś poszło nie tak</h1>
            <p className="text-[#334155] mb-6">{errorMsg}</p>
            <Link to="/register">
              <Button className="w-full brut brut-hover bg-[#0F172A] hover:bg-[#0F172A] text-white font-bold rounded-md">
                Zarejestruj się ponownie
              </Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
